/**
 * Icon — thin wrapper over the Phosphor Icons web font (spec S6). The regular
 * stylesheet is loaded once from node_modules in src/main.jsx; this component only
 * emits the glyph classes: `ph ph-{name}` for the regular weight, `ph-{weight}
 * ph-{name}` for the others. Pass a Phosphor name in kebab-case, e.g.
 * name="magnifying-glass".
 *
 * Ported from the skill's components/core/Icon.jsx. Prop NAMES are preserved
 * (name / size / weight / color / style — HANDOFF.md:27); their types are adapted to
 * the class idiom of spec S4: the reference carries size and colour as an inline
 * style object, which AC-9 bans, so both are named tiers resolved in ds.css —
 * size against the --fs-* scale, colour against the semantic text/status roles.
 * `style` and every other DOM attribute pass through unchanged.
 */
export function Icon ({ name, size = 'md', weight = 'regular', color = 'current', className, ...rest }) {
  const family = weight === 'regular' ? 'ph' : `ph-${weight}`;
  return (
    <i
      className={[family, `ph-${name}`, 'oc-icon', `oc-icon--${size}`, `oc-icon--${color}`, className]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
      {...rest}
    />
  );
}
